import script from "./QuickReplyManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./QuickReplyManagement.vue?vue&type=script&setup=true&lang=js"

import "./QuickReplyManagement.vue?vue&type=style&index=0&id=7a893132&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a893132"]])

export default __exports__